import stbAPIGateway from '../../../../services/stbAPIGateway';

export const postCsvExternalIdpOidc = async ({ rootGetters }, { clientSid, oidcIdpInfo }) => {
  const axios = rootGetters['app/stbAxios'];

  const stbApi = stbAPIGateway(axios, process.env.API_URL);

  const result = await stbApi.postHubCsvExternalIdpOidc(clientSid, oidcIdpInfo);
  return result;
};
